/**
 * Monto en soles con separador de miles: formatCurrency(3000) → "S/ 3,000.00".
 * Acepta string porque los DECIMAL del backend llegan sin cast ("516.00"),
 * y String.prototype.toLocaleString ignora las opciones de formato.
 */
const formatCurrency = (value: number | string, decimals: number = 2): string =>
  `S/ ${Number(value).toLocaleString('es-PE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;

export default formatCurrency;
